export default __webpack_public_path__ + "static/media/backspace-arrow-16px.06837c80.svg";